var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeShipingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_207)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14_207)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6357 10.6039C39.6161 10.6157 39.5962 10.6273 39.576 10.6385L13.271 25.2469C13.2707 25.2471 13.2703 25.2473 13.27 25.2475C13.0367 25.3774 12.8424 25.5673 12.707 25.7974C12.5715 26.0279 12.5 26.2905 12.5 26.5579V55.3833C12.5008 56.2742 12.7396 57.1487 13.1918 57.9164C13.6441 58.6843 14.2934 59.3173 15.0725 59.75L39.5725 73.365C40.3151 73.7774 41.1506 73.9938 42 73.9938C42.8494 73.9938 43.6849 73.7774 44.4275 73.365L68.927 59.7503C69.7065 59.3174 70.3565 58.6837 70.8088 57.9153C71.2611 57.1471 71.4997 56.2719 71.5 55.3805C71.5 55.3803 71.5 55.3806 71.5 55.3805V26.5579C71.5 26.2905 71.4285 26.028 71.293 25.7974C71.1574 25.567 70.9628 25.3769 70.7292 25.247C70.7291 25.247 70.7292 25.247 70.7292 25.247L44.4275 10.6385C44.4275 10.6384 44.4275 10.6385 44.4275 10.6385C43.6849 10.2261 42.8494 10.0096 42 10.0096C41.1746 10.0096 40.3624 10.214 39.6357 10.6039ZM37.5589 7.18319C37.5824 7.16886 37.6063 7.15497 37.6305 7.14151C38.9672 6.39918 40.471 6.00964 42 6.00964C43.529 6.00964 45.0328 6.39918 46.3695 7.14151L72.673 21.7511C73.5299 22.2276 74.2439 22.9245 74.7409 23.7697C75.238 24.6149 75.5 25.5776 75.5 26.5581V55.3805C75.4996 56.9854 75.0701 58.5615 74.2559 59.9445C73.4418 61.3276 72.2726 62.4678 70.8695 63.247L46.37 76.8617C45.0333 77.604 43.529 77.9938 42 77.9938C40.471 77.9938 38.9672 77.6043 37.6305 76.862L13.1305 63.247C11.7281 62.4682 10.5593 61.3287 9.74522 59.9465C8.93109 58.5643 8.50118 56.9896 8.5 55.3855L8.5 26.5581C8.5 26.558 8.5 26.5581 8.5 26.5581C8.49997 25.5776 8.76205 24.6149 9.25908 23.7697C9.75613 22.9245 10.4701 22.2276 11.327 21.7511L37.5589 7.18319Z",
    fill: "url(#paint0_linear_14_207)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5017 14.7787C25.0381 13.8131 26.2557 13.4653 27.2213 14.0017L58.7213 31.5017C59.3562 31.8544 59.75 32.5237 59.75 33.25V45.5C59.75 46.6046 58.8546 47.5 57.75 47.5C56.6454 47.5 55.75 46.6046 55.75 45.5V34.4268L25.2787 17.4983C24.3131 16.9619 23.9653 15.7443 24.5017 14.7787ZM19.253 42.1743C19.7907 41.2095 21.0088 40.8633 21.9737 41.401L32.4737 47.253C33.4385 47.7907 33.7847 49.0088 33.247 49.9737C32.7093 50.9385 31.4912 51.2847 30.5263 50.747L20.0263 44.895C19.0615 44.3573 18.7153 43.1392 19.253 42.1743Z",
    fill: "url(#paint1_linear_14_207)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 43.1768L9.52869 26.2483L11.4713 22.7517L42 39.7121L72.5287 22.7517L74.4713 26.2483L44 43.1768V77H40V43.1768Z",
    fill: "url(#paint2_linear_14_207)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14_207",
    x: 4.5,
    y: 6.00964,
    width: 75,
    height: 79.9841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14_207"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14_207",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_207",
    x1: 8.5,
    y1: 42.0017,
    x2: 75.5,
    y2: 42.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_207",
    x1: 18.9996,
    y1: 32.375,
    x2: 59.75,
    y2: 32.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_207",
    x1: 9.52869,
    y1: 49.8759,
    x2: 74.4713,
    y2: 49.8759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeShipingIcon);
export default __webpack_public_path__ + "static/media/free-shiping-icon.613156b44e46bef9d78642d3190611f6.svg";
export { ForwardRef as ReactComponent };